import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { Skeleton } from '../../components/ui/Skeleton'
import { useWeightEntries } from '../../hooks/useWeightEntries'
import { computeWeightDiffs } from '../../lib/phoenixUtils'
import { WeightForm } from './components/WeightForm'
import { WeightChart } from './components/WeightChart'
import { WeightHistory } from './components/WeightHistory'

export function WeightTab() {
  const { t } = useTranslation()
  const { entries, loading, error, upsertEntry, updateEntry, deleteEntry, refetch } = useWeightEntries()

  if (loading && entries.length === 0) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-20 w-full" />
      </div>
    )
  }

  if (error && entries.length === 0) {
    return (
      <Card className="border-red-500/50">
        <CardContent className="text-center py-8">
          <p className="text-red-500 mb-4">{t('phoenixTracker.error')}</p>
          <Button onClick={refetch} variant="outline">{t('phoenixTracker.retry')}</Button>
        </CardContent>
      </Card>
    )
  }

  const entriesWithDiffs = computeWeightDiffs(entries)

  return (
    <div className="space-y-4">
      <WeightForm onSubmit={upsertEntry} loading={loading} lastEntry={entries[0]} />
      {error && (
        <p className="text-sm text-red-500 text-center">{error}</p>
      )}
      <WeightChart entries={entries} />
      <WeightHistory
        entries={entriesWithDiffs}
        onUpdate={updateEntry}
        onDelete={deleteEntry}
      />
    </div>
  )
}
